
import { GolfBase } from './Golf-Base';
import { iphoneRedeemCode, iphoneGolfStore } from '../../link-actions';
import { getPromo } from '../../promos';

import Carousel from "react-multi-carousel";
import { PromoHeading } from '../promoMidSection';
import { LandingHeader } from '../LandingHeader';

const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

export const GolfHome = () => {
    const sportKey = "golf";
    const promo = getPromo(sportKey);
    return (<GolfBase 
                banner={<LandingHeader sportKey={sportKey} headline="Improve your swing" subHeading="Real-time analysis, slow-motion replays, auto-pause, casting, and more..." images={[
                    {src: "./assets/img/golf/app_store_analyse_shop.png", caption: "Real-time analysis", captionTop: '58%', imgStyle: {boxShadow: 'none', border: 'none'}},
                    {src: "./assets/img/golf/analyse.png", caption: "Real-time analysis", captionTop: '57%'},
                    {src: "./assets/img/golf/replay.png", caption: "Slow motion instant replays", captionTop: '39%'},
                    {src: "./assets/img/golf/pause.png", caption: "Auto pause and save", captionTop: '58%'},
                    {src: "./assets/img/golf/cast.png", caption: "Cast to tablet or laptop", captionTop: '37%', imgStyle: {boxShadow: 'none', border: 'none'}},
                ]} />}
                />
    
    );
}

export default GolfHome;